var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "contract-index" },
        [
          _vm.alertEditbox
            ? [
                _c(
                  "div",
                  { staticClass: "con-list-wrap z_regCon pad30-t pad35_l" },
                  [
                    _c("ul", [
                      _c("li", { staticClass: "clearfix mar20_b" }, [
                        _vm._m(0),
                        _c(
                          "div",
                          { staticClass: "pull-left " },
                          [
                            _c("el-input", {
                              staticClass: "selt w200",
                              attrs: {
                                maxlength: "30",
                                disabled: _vm.isDefault && _vm.transferAttrId,
                                placeholder: "请填写合同模板名称"
                              },
                              model: {
                                value: _vm.name,
                                callback: function($$v) {
                                  _vm.name = $$v
                                },
                                expression: "name"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm.templateMethodSel == "ZY-NXKH" ||
                    _vm.templateMethodSel == "XS-KLMY" ||
                    _vm.templateMethodSel == "XS-YR"
                      ? [
                          _c("ul", [
                            _c(
                              "li",
                              { staticClass: "clearfix mar20_b pad10-l" },
                              [_vm._v("产品（货物）型号、数量、金额")]
                            ),
                            _c(
                              "li",
                              { staticClass: "clearfix mar20_b" },
                              [
                                _vm._v("\n            短溢量：±\n            "),
                                _c("el-input-number", {
                                  staticClass: "w80 mar5 dpad5",
                                  attrs: {
                                    "controls-position": "right",
                                    size: "small",
                                    precision: 2,
                                    step: 1,
                                    min: 0.01,
                                    max: 100
                                  },
                                  model: {
                                    value: _vm.attrVal.contract22,
                                    callback: function($$v) {
                                      _vm.$set(_vm.attrVal, "contract22", $$v)
                                    },
                                    expression: "attrVal.contract22"
                                  }
                                }),
                                _vm._v(
                                  "%，\n            在此范围内根据实际交货数量及约定销售单价计算最终合同价款\n          "
                                )
                              ],
                              1
                            ),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _vm._v(
                                "\n            产品质量标准：\n            "
                              ),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              每一批次产品、货物的质量标准按以下选项约定验收，无明确规定的按照国家相关标准或农信平台规则执行：\n              "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract58,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract58",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract58"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）按照标签所示质量标准。\n                "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "2",
                                          staticClass: "checkbox-top2",
                                          attrs: { label: "2" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （2）双方约定的质量标准\n                  "
                                          ),
                                          _c("div"),
                                          _c("el-input", {
                                            staticClass: "mar5-t",
                                            staticStyle: { width: "500px" },
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入内容",
                                              maxlength: 200,
                                              "show-word-limit": ""
                                            },
                                            model: {
                                              value: _vm.attrVal.contract60,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract60",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract60"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "3", attrs: { label: "3" } },
                                        [
                                          _vm._v(
                                            "\n                  （3）按照农信商城店铺商品详情页列明的标准执行。\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("div", [_vm._v("赔付与拒收的标准")]),
                                  _c("el-input", {
                                    staticStyle: { width: "500px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract23,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract23", $$v)
                                      },
                                      expression: "attrVal.contract23"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _vm._v("\n            交 付：\n            "),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              由甲方向乙方指定下游客户交付，甲乙双方一致选择以下选项约定进行交付：\n              "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract41,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract41",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract41"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）本合同签订后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData1",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData1"
                                            }
                                          }),
                                          _vm._v(
                                            "日内，甲方向乙方指定的地点和收货人发货。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v("（2）甲方收到乙方100%货款后"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData3,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData3",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData3"
                                            }
                                          }),
                                          _vm._v(
                                            "日内，向乙方指定的地点和收货人发货。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _vm.templateMethodSel == "XS-YR" ||
                                      _vm.templateMethodSel == "XS-KLMY"
                                        ? [
                                            _c(
                                              "el-radio",
                                              {
                                                key: "3",
                                                attrs: { label: "3" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    （3）其他交付方式：\n                  "
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "mar10-t"
                                            }),
                                            _c("el-input", {
                                              staticStyle: { width: "552px" },
                                              attrs: {
                                                type: "textarea",
                                                placeholder: "请输入内容",
                                                maxlength: 200,
                                                "show-word-limit": ""
                                              },
                                              model: {
                                                value: _vm.attrVal.contract53,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.attrVal,
                                                    "contract53",
                                                    $$v
                                                  )
                                                },
                                                expression: "attrVal.contract53"
                                              }
                                            })
                                          ]
                                        : [
                                            _c(
                                              "el-radio",
                                              {
                                                key: "3",
                                                attrs: { label: "3" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    （3）约定的交货期间：从"
                                                ),
                                                _c("el-input", {
                                                  staticClass: "selt w200",
                                                  attrs: { maxlength: "11" },
                                                  model: {
                                                    value:
                                                      _vm.attrVal.contract66,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.attrVal,
                                                        "contract66",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "attrVal.contract66"
                                                  }
                                                }),
                                                _vm._v(" 到"),
                                                _c("el-input", {
                                                  staticClass: "selt w200",
                                                  attrs: { maxlength: "11" },
                                                  model: {
                                                    value:
                                                      _vm.attrVal.contract67,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.attrVal,
                                                        "contract67",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "attrVal.contract67"
                                                  }
                                                }),
                                                _vm._v(
                                                  "，这此期间，由甲方提前"
                                                ),
                                                _c("el-input-number", {
                                                  staticClass: "w80 mar5 dpad5",
                                                  attrs: {
                                                    "controls-position":
                                                      "right",
                                                    size: "small",
                                                    step: 1,
                                                    min: 0,
                                                    max: 300
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.attrVal.contract68,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.attrVal,
                                                        "contract68",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "attrVal.contract68"
                                                  }
                                                }),
                                                _vm._v(
                                                  "天通知乙方提货或分期提货。\n                  "
                                                )
                                              ],
                                              1
                                            ),
                                            _c("div", {
                                              staticClass: "mar10-t"
                                            }),
                                            _c(
                                              "el-radio",
                                              {
                                                key: "4",
                                                attrs: { label: "4" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    （4）其他交付方式：\n                  "
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "mar10-t"
                                            }),
                                            _c("el-input", {
                                              staticStyle: { width: "552px" },
                                              attrs: {
                                                type: "textarea",
                                                placeholder: "请输入内容",
                                                maxlength: 200,
                                                "show-word-limit": ""
                                              },
                                              model: {
                                                value: _vm.attrVal.contract53,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.attrVal,
                                                    "contract53",
                                                    $$v
                                                  )
                                                },
                                                expression: "attrVal.contract53"
                                              }
                                            })
                                          ]
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "mar20-t" },
                                    [
                                      _vm._v(
                                        "\n                交货方式及运费承担：采用选择以下选项方式交货"
                                      ),
                                      _c("font", { staticClass: "red" }, [
                                        _vm._v("（默认获取订单配送方式）")
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract18,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract18",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract18"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）甲方直接送货或委托第三方送货，该商品自送到乙方指定地点并由指定接收人或下单人签收的（指在电子签署单上签收或在订单上确认收货），视为乙方收货完成，甲方委托第三方快递公司配送的，自配送到乙方指定地点的，视为乙方收货完成，其相关的运费由甲方承担。\n                "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "\n                  （2）乙方指定人员上门提货，自乙方指定人员或下单人员签署电子签收单或通过农信商城确认收货的，视为乙方收货完成，运费由乙方承担。\n                "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "3", attrs: { label: "3" } },
                                        [
                                          _vm._v(
                                            "\n                  （3）其他方式\n                "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c("el-input", {
                                        staticStyle: { width: "552px" },
                                        attrs: {
                                          type: "textarea",
                                          placeholder: "请输入内容",
                                          maxlength: 200,
                                          "show-word-limit": ""
                                        },
                                        model: {
                                          value: _vm.attrVal.contract61,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.attrVal,
                                              "contract61",
                                              $$v
                                            )
                                          },
                                          expression: "attrVal.contract61"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _c("div", { staticClass: "nowrap" }, [
                                _vm._v("产品验收：")
                              ]),
                              _c("div", [
                                _c(
                                  "div",
                                  [
                                    _vm._v(
                                      "\n                乙方应按平台规定的交易流程进行确认收货，按平台交易规定确认收货后则视为乙方已经收到货物，乙方在确认收货后\n                "
                                    ),
                                    _c("el-input-number", {
                                      staticClass: "w80 mar5 dpad5",
                                      attrs: {
                                        "controls-position": "right",
                                        size: "small",
                                        precision: 2,
                                        step: 1,
                                        min: 0.01,
                                        max: 300
                                      },
                                      model: {
                                        value: _vm.attrVal.contract33,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract33",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract33"
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  日内，应及时查验商品数量及质量，如发现数量及质量有问题的，应及时通过平台订单“售后”系统，向甲方及平台方提出书面异议，超过\n                "
                                    ),
                                    _c("el-input-number", {
                                      staticClass: "w80 mar5 dpad5",
                                      attrs: {
                                        "controls-position": "right",
                                        size: "small",
                                        precision: 2,
                                        step: 1,
                                        min: 0.01,
                                        max: 300
                                      },
                                      model: {
                                        value: _vm.attrVal.contract34,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract34",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract34"
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  日未提出书面异议的，则视为乙方收到的货物质量合格。甲方有权申请按照平台规则进行结算支付货款\n              "
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _c("div", { staticClass: "nowrap" }, [
                                _vm._v("货款结算：")
                              ]),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              结算与付款方式：根据农信平台支付规则进行线上支付结算，甲乙双方一致选择以下选项结算方式\n              "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract40,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract40",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract40"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）先款后货，乙方在本合同签订"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData4,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData4",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData4"
                                            }
                                          }),
                                          _vm._v(
                                            "天内，通过农信商城平台先行全额预付或结算给甲方款项，乙方可一次性或分批提货，多余部分由甲方通过平台退还。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "\n                  （2）货到付款，乙方或指定收货人对该订单或批次货物验收合格并确认收货后（签署电子签收单）"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData15,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData15",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData15"
                                            }
                                          }),
                                          _vm._v(
                                            "日内，乙方将全部货款通过平台结算给甲方。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        { key: "3", attrs: { label: "3" } },
                                        [
                                          _vm._v(
                                            "\n                  （3）分次付款，本合同签署后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData5,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData5",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData5"
                                            }
                                          }),
                                          _vm._v("日内乙方付"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData6,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData6",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData6"
                                            }
                                          }),
                                          _vm._v(
                                            "%款项，产品、货物装车/装船后当日内乙方付"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData7,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData7",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData7"
                                            }
                                          }),
                                          _vm._v("%款项，"),
                                          _c("br"),
                                          _vm._v("乙方指定收货人确认收货后"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData8,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData8",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData8"
                                            }
                                          }),
                                          _vm._v("日内乙方付"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData9,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData9",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData9"
                                            }
                                          }),
                                          _vm._v("%款项\n                ")
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "4",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "4" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （4）先验后款，乙方指定收货人收到货物后（签署电子签收单）并验收合格后的"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              step: 1,
                                              min: 0,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contract72,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract72",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract72"
                                            }
                                          }),
                                          _vm._v(
                                            "日内通过平台将全款结算给甲方。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "5",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "5" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （5）限定天数结算。乙方应在甲方发货后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData14,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData14",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData14"
                                            }
                                          }),
                                          _vm._v(
                                            "日内将全部货款通过平台结算给甲方。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "6",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "6" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （6）按发货进度付款：合同签订后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              step: 1,
                                              min: 0,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contract73,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract73",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract73"
                                            }
                                          }),
                                          _vm._v("日内支付合同总额的"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contract74,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract74",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract74"
                                            }
                                          }),
                                          _vm._v(
                                            "%作为定金即\n                    "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w200 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01
                                            },
                                            model: {
                                              value: _vm.attrVal.contract75,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract75",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract75"
                                            }
                                          }),
                                          _vm._v(
                                            "元，剩余货款在每次提货前支付，"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "已支付定金在需方最后一次提货时转为货款结算。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "7",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "7" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （7）固定时间节点结算，乙方于每月"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData11,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData11",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData11"
                                            }
                                          }),
                                          _vm._v(
                                            "日将指定收货人验收合格并确认收货但未结算的货款通过平台结算给甲方。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "8", attrs: { label: "8" } },
                                        [
                                          _vm._v(
                                            "\n                  （8）其他结算方式\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "mar10-t" }),
                                  _c("el-input", {
                                    staticStyle: { width: "528px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract54,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract54", $$v)
                                      },
                                      expression: "attrVal.contract54"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _vm._v("\n            违约责任：\n            "),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              特别约定\n              "
                                  ),
                                  _c("div"),
                                  _c("el-input", {
                                    staticStyle: { width: "528px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract25,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract25", $$v)
                                      },
                                      expression: "attrVal.contract25"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c(
                              "li",
                              { staticClass: "clearfix flex pad10-l mar20_b" },
                              [
                                _vm._v(
                                  "\n            补充条款：\n            "
                                ),
                                _c(
                                  "div",
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "528px" },
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "请输入内容",
                                        maxlength: 200,
                                        "show-word-limit": ""
                                      },
                                      model: {
                                        value: _vm.attrVal.contract26,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract26",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract26"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      : _vm.templateMethodSel == "CG-NXKH" ||
                        _vm.templateMethodSel == "CG-KLMY" ||
                        _vm.templateMethodSel == "CG-YR"
                      ? [
                          _c("ul", [
                            _c(
                              "li",
                              { staticClass: "clearfix mar20_b pad10-l" },
                              [_vm._v("产品（货物）型号、数量、金额")]
                            ),
                            _c(
                              "li",
                              { staticClass: "clearfix mar20_b" },
                              [
                                _vm._v("\n            短溢量：±\n            "),
                                _c("el-input-number", {
                                  staticClass: "w80 mar5 dpad5",
                                  attrs: {
                                    "controls-position": "right",
                                    size: "small",
                                    precision: 2,
                                    step: 1,
                                    min: 0.01,
                                    max: 100
                                  },
                                  model: {
                                    value: _vm.attrVal.contract22,
                                    callback: function($$v) {
                                      _vm.$set(_vm.attrVal, "contract22", $$v)
                                    },
                                    expression: "attrVal.contract22"
                                  }
                                }),
                                _vm._v(
                                  "%，在此范围内根据实际交货数量及约定销售单价计算最终合同价款\n          "
                                )
                              ],
                              1
                            ),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _vm._v(
                                "\n            产品质量标准：\n            "
                              ),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              每一批次产品、货物的质量标准按以下选项约定验收，无明确规定的按照国家相关标准或农信平台规则执行：\n              "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract58,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract58",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract58"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）按照标签所示质量标准\n                "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "2",
                                          staticClass: "checkbox-top2",
                                          attrs: { label: "2" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （2）双方约定的质量标准\n                  "
                                          ),
                                          _c("div"),
                                          _c("el-input", {
                                            staticClass: "mar5-t",
                                            staticStyle: { width: "500px" },
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入内容",
                                              maxlength: 200,
                                              "show-word-limit": ""
                                            },
                                            model: {
                                              value: _vm.attrVal.contract60,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract60",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract60"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "3", attrs: { label: "3" } },
                                        [
                                          _vm._v(
                                            "\n                  （3）按农信商城商品详情页列明的商品标准执行。\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("div", [_vm._v("赔付与拒收的标准")]),
                                  _c("el-input", {
                                    staticStyle: { width: "500px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract23,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract23", $$v)
                                      },
                                      expression: "attrVal.contract23"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _c("div", { staticClass: "nowrap" }, [
                                _vm._v("交 付：")
                              ]),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              甲乙双方一致选择以下选项约定进行交付：\n              "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract41,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract41",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract41"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）本合同签订后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData1",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData1"
                                            }
                                          }),
                                          _vm._v(
                                            "日内，甲方向乙方或乙方下游买方指定的地点和收货人发货（向乙方指定收货人送达货物即视为向乙方送达货物）。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "\n                  （2）甲方收到乙方"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData2"
                                            }
                                          }),
                                          _vm._v("%货款后"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData3,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData3",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData3"
                                            }
                                          }),
                                          _vm._v(
                                            "日内，向乙方指定的地点和收货人发货。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _vm.templateMethodSel == "CG-YR" ||
                                      _vm.templateMethodSel == "CG-KLMY"
                                        ? [
                                            _c(
                                              "el-radio",
                                              {
                                                key: "3",
                                                attrs: { label: "3" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    （3）其他交付方式：\n                  "
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "mar10-t"
                                            }),
                                            _c("el-input", {
                                              staticStyle: { width: "552px" },
                                              attrs: {
                                                type: "textarea",
                                                placeholder: "请输入内容",
                                                maxlength: 200,
                                                "show-word-limit": ""
                                              },
                                              model: {
                                                value: _vm.attrVal.contract53,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.attrVal,
                                                    "contract53",
                                                    $$v
                                                  )
                                                },
                                                expression: "attrVal.contract53"
                                              }
                                            })
                                          ]
                                        : [
                                            _c(
                                              "el-radio",
                                              {
                                                key: "3",
                                                attrs: { label: "3" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    （3）约定的交货期间：从"
                                                ),
                                                _c("el-input", {
                                                  staticClass: "selt w200",
                                                  attrs: { maxlength: "11" },
                                                  model: {
                                                    value:
                                                      _vm.attrVal.contract66,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.attrVal,
                                                        "contract66",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "attrVal.contract66"
                                                  }
                                                }),
                                                _vm._v(" 到"),
                                                _c("el-input", {
                                                  staticClass: "selt w200",
                                                  attrs: { maxlength: "11" },
                                                  model: {
                                                    value:
                                                      _vm.attrVal.contract67,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.attrVal,
                                                        "contract67",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "attrVal.contract67"
                                                  }
                                                }),
                                                _vm._v(
                                                  "，这此期间，由甲方提前"
                                                ),
                                                _c("el-input-number", {
                                                  staticClass: "w80 mar5 dpad5",
                                                  attrs: {
                                                    "controls-position":
                                                      "right",
                                                    size: "small",
                                                    step: 1,
                                                    min: 0,
                                                    max: 300
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.attrVal.contract68,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.attrVal,
                                                        "contract68",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "attrVal.contract68"
                                                  }
                                                }),
                                                _vm._v(
                                                  "天通知乙方提货或分期提货。\n                  "
                                                )
                                              ],
                                              1
                                            ),
                                            _c("div", {
                                              staticClass: "mar10-t"
                                            }),
                                            _c(
                                              "el-radio",
                                              {
                                                key: "4",
                                                attrs: { label: "4" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    （4）其他交付方式：\n                  "
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "mar10-t"
                                            }),
                                            _c("el-input", {
                                              staticStyle: { width: "552px" },
                                              attrs: {
                                                type: "textarea",
                                                placeholder: "请输入内容",
                                                maxlength: 200,
                                                "show-word-limit": ""
                                              },
                                              model: {
                                                value: _vm.attrVal.contract53,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.attrVal,
                                                    "contract53",
                                                    $$v
                                                  )
                                                },
                                                expression: "attrVal.contract53"
                                              }
                                            })
                                          ]
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _c("div"),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n                交货方式：双方一致同意按照以下方式进行交货。\n                "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract69,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract69",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract69"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                    （1）甲方直接送货或委托第三方送货，该商品自送到乙方指定地点并由指定接收人或下单人签收的（指在电子签署单上签收或在订单上确认收货），"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "视为乙方收货完成，甲方委托第三方快递公司配送的，自配送到乙方指定地点的，视为乙方收货完成，其相关的运费由甲方承担。\n                  "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "\n                    （2）乙方指定人员上门提货，自乙方指定人员或下单人员签署电子签收单或通过农信商城确认收货的，视为乙方收货完成，其相关的运费由乙方承担。\n                  "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "3", attrs: { label: "3" } },
                                        [
                                          _vm._v(
                                            "\n                    （3）甲方将乙方订购货物暂存于甲方或第三方仓库，自乙方通过农信商城确认由甲方发出的提货单后，该商品的所有权即归乙方所有，乙方享有完全的\n                  "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "处置该商品的权利，甲方不得自行处置或将该商品转卖给其他第三方。该方式下，甲方按照乙方提货要求，应在约定时间内将货物转交给乙方指定的\n                "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "收货人，当收货人或下单人签署电子签收单或通过农信商城确认收货的，视为乙方收货完成，其相关的运费由乙方\n                    承担。\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _c("div"),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n                双方约定按照以下项确定交货地址\n                "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract70,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract70",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract70"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                    （1）以订单上标识的指定交货地址为准\n                  "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "\n                    （2）由甲方指定提货地点，提前"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              step: 1,
                                              min: 0,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contract71,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract71",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract71"
                                            }
                                          }),
                                          _vm._v(
                                            "天通知乙方（通过订单信息）\n                  "
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _c("div", { staticClass: "nowrap" }, [
                                _vm._v("货款结算：")
                              ]),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              结算与付款方式：根据农信平台支付规则进行线上支付结算，甲乙双方一致选择以下选项结算方式\n              "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract40,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract40",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract40"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）先款后货，乙方在本合同签订"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData4,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData4",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData4"
                                            }
                                          }),
                                          _vm._v(
                                            "天内，通过农信商城平台先行全额预付或结算给甲方款项，乙方可一次性或分批提货，多余部分由甲方通过平台退还。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "\n                  （2）货到付款，乙方或指定收货人对该订单或批次货物验收合格并确认收货后（签署电子签收单）"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData15,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData15",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData15"
                                            }
                                          }),
                                          _vm._v(
                                            "日内，乙方将全部货款通过平台结算给甲方。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        { key: "3", attrs: { label: "3" } },
                                        [
                                          _vm._v(
                                            "\n                  （3）分次付款，本合同签署后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData5,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData5",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData5"
                                            }
                                          }),
                                          _vm._v("日内乙方付"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData6,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData6",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData6"
                                            }
                                          }),
                                          _vm._v(
                                            "%款项，产品、货物装车/装船后当日内乙方付"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData7,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData7",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData7"
                                            }
                                          }),
                                          _vm._v("%款项，"),
                                          _c("br"),
                                          _vm._v("乙方指定收货人确认收货后"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData8,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData8",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData8"
                                            }
                                          }),
                                          _vm._v("日内乙方付"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData9,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData9",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData9"
                                            }
                                          }),
                                          _vm._v("%款项\n                ")
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "4",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "4" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （4）先验后款，乙方指定收货人收到货物后（签署电子签收单）并验收合格后的"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              step: 1,
                                              min: 0,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contract72,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract72",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract72"
                                            }
                                          }),
                                          _vm._v(
                                            "日内通过平台将全款结算给甲方。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "5",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "5" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （5）限定天数结算。乙方应在甲方发货后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData14,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData14",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData14"
                                            }
                                          }),
                                          _vm._v(
                                            "日内将全部货款通过平台结算给甲方。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "6",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "6" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （6）按发货进度付款：合同签订后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              step: 1,
                                              min: 0,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contract73,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract73",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract73"
                                            }
                                          }),
                                          _vm._v("日内支付合同总额的"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contract74,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract74",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract74"
                                            }
                                          }),
                                          _vm._v(
                                            "%作为定金即\n                    "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w200 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01
                                            },
                                            model: {
                                              value: _vm.attrVal.contract75,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract75",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract75"
                                            }
                                          }),
                                          _vm._v(
                                            "元，剩余货款在每次提货前支付，"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "已支付定金在需方最后一次提货时转为货款结算。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "7",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "7" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （7）固定时间节点结算，乙方于每月"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData11,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData11",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData11"
                                            }
                                          }),
                                          _vm._v(
                                            "日将指定收货人验收合格并确认收货但未结算的货款通过平台结算给甲方。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "8", attrs: { label: "8" } },
                                        [
                                          _vm._v(
                                            "\n                  （8）其他结算方式\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "mar10-t" }),
                                  _c("el-input", {
                                    staticStyle: { width: "528px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract54,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract54", $$v)
                                      },
                                      expression: "attrVal.contract54"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _vm._v("\n            违约责任：\n            "),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              特别约定\n              "
                                  ),
                                  _c("div"),
                                  _c("el-input", {
                                    staticStyle: { width: "528px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract25,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract25", $$v)
                                      },
                                      expression: "attrVal.contract25"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c(
                              "li",
                              { staticClass: "clearfix flex pad10-l mar20_b" },
                              [
                                _vm._v(
                                  "\n            补充条款：\n            "
                                ),
                                _c(
                                  "div",
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "528px" },
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "请输入内容",
                                        maxlength: 200,
                                        "show-word-limit": ""
                                      },
                                      model: {
                                        value: _vm.attrVal.contract26,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract26",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract26"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      : _vm.templateMethodSel == "XS-PTKH"
                      ? [
                          _c("ul", [
                            _c(
                              "li",
                              { staticClass: "clearfix mar20_b pad10-l" },
                              [_vm._v("产品（货物）型号、数量、金额")]
                            ),
                            _c(
                              "li",
                              { staticClass: "clearfix mar20_b" },
                              [
                                _vm._v("\n            短溢量：±\n            "),
                                _c("el-input-number", {
                                  staticClass: "w80 mar5 dpad5",
                                  attrs: {
                                    "controls-position": "right",
                                    size: "small",
                                    precision: 2,
                                    step: 1,
                                    min: 0.01,
                                    max: 100
                                  },
                                  model: {
                                    value: _vm.attrVal.contract22,
                                    callback: function($$v) {
                                      _vm.$set(_vm.attrVal, "contract22", $$v)
                                    },
                                    expression: "attrVal.contract22"
                                  }
                                }),
                                _vm._v(
                                  "%，此范围内根据实际交货数量及约定销售单价计算最终合同价款。\n          "
                                )
                              ],
                              1
                            ),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "relative",
                                  staticStyle: { top: "-14px" }
                                },
                                [_vm._v("产品质量标准：")]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract58,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract58",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract58"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）按照标签所示质量标准\n                "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "2",
                                          staticClass: "checkbox-top2",
                                          attrs: { label: "2" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （2）双方约定的质量标准\n                  "
                                          ),
                                          _c("div"),
                                          _c("el-input", {
                                            staticClass: "mar5-t",
                                            staticStyle: { width: "500px" },
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入内容",
                                              maxlength: 200,
                                              "show-word-limit": ""
                                            },
                                            model: {
                                              value: _vm.attrVal.contract60,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contract60",
                                                  $$v
                                                )
                                              },
                                              expression: "attrVal.contract60"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("div", [_vm._v("赔付与拒收的标准")]),
                                  _c("el-input", {
                                    staticStyle: { width: "500px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract23,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract23", $$v)
                                      },
                                      expression: "attrVal.contract23"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _vm._v("\n            交 付：\n            "),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              由甲方上游供应商直接向乙方交付，甲乙双方一致选择以下选项约定进行交付\n              "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract41,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract41",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract41"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）本合同签订后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData1",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData1"
                                            }
                                          }),
                                          _vm._v(
                                            "日内，甲方上游供应商向乙方指定的地点和收货人发货（向乙方指定收货人送达货物即视为乙方签收货物）\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "\n                  （2）甲方收到乙方"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData2"
                                            }
                                          }),
                                          _vm._v("%货款后"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData3,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData3",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData3"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  日内，甲方上游供应商向乙方指定的地点和收货人发货\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div"),
                                      _c(
                                        "el-radio",
                                        { key: "3", attrs: { label: "3" } },
                                        [
                                          _vm._v(
                                            "\n                  （3）其他交付方式：\n                "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c("el-input", {
                                        staticStyle: { width: "552px" },
                                        attrs: {
                                          type: "textarea",
                                          placeholder: "请输入内容",
                                          maxlength: 200,
                                          "show-word-limit": ""
                                        },
                                        model: {
                                          value: _vm.attrVal.contract53,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.attrVal,
                                              "contract53",
                                              $$v
                                            )
                                          },
                                          expression: "attrVal.contract53"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _c("div", { staticClass: "nowrap" }, [
                                _vm._v("货款结算：")
                              ]),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              结算与付款方式：根据农信平台支付规则进行线上支付结算，甲乙双方一致选择以下选项结算方式\n              "
                                  ),
                                  _c("div"),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.attrVal.contract40,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract40",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract40"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { key: "1", attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "\n                  （1）先款后货，本合同签署后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData4,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData4",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData4"
                                            }
                                          }),
                                          _vm._v(
                                            "日内，乙方通过平台将全款结算给甲方，甲方根据与其上游供应商的约定进行结算支付\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "2", attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "\n                  （2）货到付款，乙方及其指定收货人收到订单货物的当日将全部货款通过平台结算给甲方，甲方根据与其上游供应商的约定进行结算支付\n                "
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        {
                                          key: "3",
                                          staticClass: "checkbox-top",
                                          attrs: { label: "3" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  （3）分次付款，本合同签署后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData5,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData5",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData5"
                                            }
                                          }),
                                          _vm._v("日内乙方付"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData6,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData6",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData6"
                                            }
                                          }),
                                          _vm._v(
                                            "%款项，产品、货物装车/装船后当日内乙方付"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData7,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData7",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData7"
                                            }
                                          }),
                                          _c("br"),
                                          _vm._v(
                                            "%款项，乙方及其指定收货人确认收货后"
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 300
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData8,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData8",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData8"
                                            }
                                          }),
                                          _vm._v("日内向甲方付"),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            model: {
                                              value: _vm.attrVal.contractData9,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.attrVal,
                                                  "contractData9",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "attrVal.contractData9"
                                            }
                                          }),
                                          _vm._v(
                                            "%款项，甲方将收到的款项按照与其上游供应商的约定结算给上游供应商\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "mar10-t" }),
                                      _c(
                                        "el-radio",
                                        { key: "4", attrs: { label: "4" } },
                                        [
                                          _vm._v(
                                            "\n                  （4）其他结算方式\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "mar10-t" }),
                                  _c("el-input", {
                                    staticStyle: { width: "528px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract54,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract54", $$v)
                                      },
                                      expression: "attrVal.contract54"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("li", { staticClass: "clearfix flex mar20_b" }, [
                              _vm._v("\n            违约责任：\n            "),
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              甲乙双方对于违约责任的特别约定\n              "
                                  ),
                                  _c("div"),
                                  _c("el-input", {
                                    staticStyle: { width: "528px" },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: 200,
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.attrVal.contract25,
                                      callback: function($$v) {
                                        _vm.$set(_vm.attrVal, "contract25", $$v)
                                      },
                                      expression: "attrVal.contract25"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c(
                              "li",
                              { staticClass: "clearfix flex pad10-l mar20_b" },
                              [
                                _vm._v(
                                  "\n            补充条款：\n            "
                                ),
                                _c(
                                  "div",
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "528px" },
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "请输入内容",
                                        maxlength: 200,
                                        "show-word-limit": ""
                                      },
                                      model: {
                                        value: _vm.attrVal.contract26,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.attrVal,
                                            "contract26",
                                            $$v
                                          )
                                        },
                                        expression: "attrVal.contract26"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      : _vm.templateMethodSel == "SHEBEI_CONTRACT"
                      ? [
                          _c("ul", [
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _vm._m(1),
                              _c(
                                "div",
                                { staticClass: "pull-left " },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择合同模板类型",
                                        disabled: _vm.attrId != 0
                                      },
                                      model: {
                                        value: _vm.templateMethodSel,
                                        callback: function($$v) {
                                          _vm.templateMethodSel = $$v
                                        },
                                        expression: "templateMethodSel"
                                      }
                                    },
                                    _vm._l(
                                      _vm.contractTemplateTypeList,
                                      function(option) {
                                        return _c("el-option", {
                                          key: option.val,
                                          attrs: {
                                            label: option.text,
                                            value: option.val
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._m(2),
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _c(
                                "div",
                                { staticClass: "pull-left pad15_l pad30_r" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "clear paymethod" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "clearfix" },
                                        [
                                          _c("em", { staticClass: "red" }, [
                                            _vm._v("*")
                                          ]),
                                          _vm._v(
                                            "交货时间：乙方或乙方上游供应商应当于甲方在农信商城下单后\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 15
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.paymentMethodSheBeiValue[1],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.paymentMethodSheBeiValue,
                                                  1,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "paymentMethodSheBeiValue[1]"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  日内发货。但双方另有约定的，从约定。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "box10" }),
                                      _c(
                                        "div",
                                        { staticClass: "clearfix" },
                                        [
                                          _c("em", { staticClass: "red" }, [
                                            _vm._v("*")
                                          ]),
                                          _vm._v(
                                            "\n                  确认收货：甲方收到货物后应在\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 100
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.paymentMethodSheBeiValue[2],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.paymentMethodSheBeiValue,
                                                  2,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "paymentMethodSheBeiValue[2]"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  日内在农信商城平台确认收货。超过\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 15
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.paymentMethodSheBeiValue[3],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.paymentMethodSheBeiValue,
                                                  3,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "paymentMethodSheBeiValue[3]"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  日乙方系统将自动确认收货。确认收货后，仅有质量问题的产品支持换货或退货。\n                "
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._m(3),
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _vm._m(4),
                              _c(
                                "div",
                                { staticClass: "pull-left " },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "800px" },
                                      attrs: {
                                        placeholder: "请选择安装和培训方式"
                                      },
                                      model: {
                                        value: _vm.installTransportModeSel,
                                        callback: function($$v) {
                                          _vm.installTransportModeSel = $$v
                                        },
                                        expression: "installTransportModeSel"
                                      }
                                    },
                                    _vm._l(
                                      _vm.installTransportModeList,
                                      function(option) {
                                        return _c("el-option", {
                                          key: option.val,
                                          attrs: {
                                            label: option.text,
                                            value: option.val
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._m(5),
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _c(
                                "div",
                                { staticClass: "pull-left pad15_l pad30_r" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "clear paymethod" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "clearfix" },
                                        [
                                          _c("em", { staticClass: "red" }, [
                                            _vm._v("*")
                                          ]),
                                          _vm._v(
                                            "\n                  甲方收到本合同所包含的全部货物后，按照乙方或其上游供应商提供的装箱清单对货物进行验收，如产品的规格、型号与合同约定不符、外形损坏或者数量缺失的，甲方应在收到货物\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 15
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.motorTransportAcceptanceDays,
                                              callback: function($$v) {
                                                _vm.motorTransportAcceptanceDays = $$v
                                              },
                                              expression:
                                                "motorTransportAcceptanceDays"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  日内向乙方提出书面异议，逾期未提出异议视为验收合格。"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                  乙方或其上游供应商在收到甲方通知且核实后\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 15
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.replacementDays,
                                              callback: function($$v) {
                                                _vm.replacementDays = $$v
                                              },
                                              expression: "replacementDays"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  日内负责换货或者补货。\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "box10" }),
                                      _c(
                                        "div",
                                        { staticClass: "clearfix" },
                                        [
                                          _c("em", { staticClass: "red" }, [
                                            _vm._v("*")
                                          ]),
                                          _vm._v(
                                            "\n                  甲方应于到货后及时安排己方或乙方所派技术人员对设备进行安装、调试，如发现产品存在质量问题的，甲方应于\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 15
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.secondPartyInspectionDays,
                                              callback: function($$v) {
                                                _vm.secondPartyInspectionDays = $$v
                                              },
                                              expression:
                                                "secondPartyInspectionDays"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  日内提出书面异议及依据，由乙方或其上游供应商核实后负责更换合格产品，无法更换的予以退货；甲方逾期提出异议，视为产品质量验收合格。"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                  甲方收到货后\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 15
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.motorTransportInspectionDays,
                                              callback: function($$v) {
                                                _vm.motorTransportInspectionDays = $$v
                                              },
                                              expression:
                                                "motorTransportInspectionDays"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  日未进行安装、调试的，视为产品质量合格。\n                "
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._m(6),
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _c(
                                "div",
                                { staticClass: "pull-left pad15_l pad30_r" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "clear paymethod" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "clearfix" },
                                        [
                                          _c("em", { staticClass: "red" }, [
                                            _vm._v("*")
                                          ]),
                                          _vm._v(
                                            "\n                  设备保修期为\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 10
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.specialQualityAgreement,
                                              callback: function($$v) {
                                                _vm.specialQualityAgreement = $$v
                                              },
                                              expression:
                                                "specialQualityAgreement"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  年，自乙方交付之日起算。\n                "
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._m(7),
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _c(
                                "div",
                                { staticClass: "pull-left pad15_l pad30_r" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "clear paymethod" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "clearfix" },
                                        [
                                          _c("em", { staticClass: "red" }, [
                                            _vm._v("*")
                                          ]),
                                          _vm._v(
                                            "\n                  乙方逾期交付设备的，每逾期一日，按未交付设备货款的\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 2,
                                              step: 1,
                                              min: 0.01,
                                              max: 100
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.firstPartyFalsifyRate,
                                              callback: function($$v) {
                                                _vm.firstPartyFalsifyRate = $$v
                                              },
                                              expression:
                                                "firstPartyFalsifyRate"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  ‰计算违约金，违约金最高不超过合同总价的10%。"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                  逾期\n                  "
                                          ),
                                          _c("el-input-number", {
                                            staticClass: "w80 mar5 dpad5",
                                            attrs: {
                                              "controls-position": "right",
                                              size: "small",
                                              precision: 0,
                                              step: 1,
                                              min: 1,
                                              max: 15
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputNumberChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.firstPartyFalsifyDays,
                                              callback: function($$v) {
                                                _vm.firstPartyFalsifyDays = $$v
                                              },
                                              expression:
                                                "firstPartyFalsifyDays"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  天仍未交货的，甲方有权终止合同，乙方应返还甲方预付款并支付逾期违约金。\n                "
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._m(8),
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _c(
                                "div",
                                { staticClass: "pull-left pad15_l pad30_r" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "clear paymethod" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "clearfix" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "pad10_r block normal"
                                            },
                                            [_vm._v("电子合同补充条款")]
                                          ),
                                          _c("el-input", {
                                            staticStyle: { width: "500px" },
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入内容",
                                              maxlength: 200,
                                              "show-word-limit": ""
                                            },
                                            model: {
                                              value: _vm.contractSupplement,
                                              callback: function($$v) {
                                                _vm.contractSupplement = $$v
                                              },
                                              expression: "contractSupplement"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      : _vm.templateMethodSel == "VIP_CONTRACT"
                      ? [
                          _c("ul", [
                            _vm._m(9),
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _vm._m(10),
                              _c(
                                "div",
                                { staticClass: "pull-left " },
                                [
                                  _vm._v(
                                    "\n              甲方应根据以下\n              "
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择支付方式" },
                                      model: {
                                        value: _vm.paymentMethodVipValue,
                                        callback: function($$v) {
                                          _vm.paymentMethodVipValue = $$v
                                        },
                                        expression: "paymentMethodVipValue"
                                      }
                                    },
                                    _vm._l(_vm.paymentMethodVipList, function(
                                      option
                                    ) {
                                      return _c("el-option", {
                                        key: option.val,
                                        attrs: {
                                          label: option.name,
                                          value: option.val
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  _vm._v(
                                    "\n              方式支付VIP商城会员服务费\n            "
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._m(11),
                            _c("li", { staticClass: "clearfix mar20_b" }, [
                              _c(
                                "div",
                                { staticClass: "pull-left pad15_l pad30_r" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "clear paymethod" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "clearfix" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "pad10_r block normal"
                                            },
                                            [_vm._v("电子合同补充条款")]
                                          ),
                                          _c("el-input", {
                                            staticStyle: { width: "500px" },
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入内容",
                                              maxlength: 200,
                                              "show-word-limit": ""
                                            },
                                            model: {
                                              value: _vm.contractSupplement,
                                              callback: function($$v) {
                                                _vm.contractSupplement = $$v
                                              },
                                              expression: "contractSupplement"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      : [
                          _c(
                            "ul",
                            [
                              _vm.templateMethodSel != "XS-PTKH"
                                ? _c(
                                    "li",
                                    { staticClass: "clearfix mar20_b" },
                                    [
                                      _vm._m(12),
                                      _c(
                                        "div",
                                        { staticClass: "pull-left" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder:
                                                  "请选择合同模板类型",
                                                disabled:
                                                  _vm.attrId != 0 &&
                                                  _vm.transferAttrId
                                              },
                                              model: {
                                                value: _vm.templateMethodSel,
                                                callback: function($$v) {
                                                  _vm.templateMethodSel = $$v
                                                },
                                                expression: "templateMethodSel"
                                              }
                                            },
                                            _vm._l(
                                              _vm.templateMethodList,
                                              function(option) {
                                                return _c("el-option", {
                                                  key: option.val,
                                                  attrs: {
                                                    label: option.text,
                                                    value: option.val
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.templateMethodSel == "PT-PTKH"
                                ? [
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _vm._m(13),
                                        _c(
                                          "div",
                                          { staticClass: "pull-left " },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择支付方式"
                                                },
                                                on: {
                                                  change: _vm.paymentMethodSel
                                                },
                                                model: {
                                                  value:
                                                    _vm.paymentMethodValue[0],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.paymentMethodValue,
                                                      0,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "paymentMethodValue[0]"
                                                }
                                              },
                                              _vm._l(
                                                _vm.paymentMethodList,
                                                function(option) {
                                                  return _c("el-option", {
                                                    key: option.val,
                                                    attrs: {
                                                      label: option.text.split(
                                                        ","
                                                      )[0],
                                                      value: option.val
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pull-left pad15_l pad30_r",
                                            staticStyle: {
                                              "padding-left": "90px"
                                            }
                                          },
                                          [
                                            _vm.paymentMethodValue[0] ==
                                            "多次支付"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clearfix normal pad35_l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  本合同签署后\n                  "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[1],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[1]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内付\n                  "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[2],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            2,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[2]"
                                                      }
                                                    }),
                                                    _vm._v("%款项，"),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  产品、货物装车/装船后 当日内付"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[3],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            3,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[3]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "%款项，\n                  确认收货后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[4],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            4,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[4]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内付\n                  "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[5],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            5,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[5]"
                                                      }
                                                    }),
                                                    _vm._v("%款项，"),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  支付首笔款后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[6],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            6,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[6]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内发货。\n                "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.paymentMethodValue[0] ==
                                            "先款后货"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clearfix normal pad35_l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  本合同签署后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[1],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[1]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                  日内付全款，付款后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[2],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            2,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[2]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内发货。\n                "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.paymentMethodValue[0] ==
                                            "先货后款"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clearfix normal pad35_l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  本合同签署后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[1],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[1]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                  日内发货，验收合格后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodValue[2],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodValue,
                                                            2,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodValue[2]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内付全款。\n                "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "clearfix pad30_l"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "pad10_r block normal"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "客户对货品质量标准的特别约定"
                                                    )
                                                  ]
                                                ),
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "500px"
                                                  },
                                                  attrs: {
                                                    type: "textarea",
                                                    placeholder: "请输入内容",
                                                    maxlength: 200,
                                                    "show-word-limit": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.specialQualityAgreement,
                                                    callback: function($$v) {
                                                      _vm.specialQualityAgreement = $$v
                                                    },
                                                    expression:
                                                      "specialQualityAgreement"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _vm._m(14),
                                        _c(
                                          "div",
                                          { staticClass: "pull-left " },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择运输方式"
                                                },
                                                model: {
                                                  value: _vm.transportModeSel,
                                                  callback: function($$v) {
                                                    _vm.transportModeSel = $$v
                                                  },
                                                  expression: "transportModeSel"
                                                }
                                              },
                                              _vm._l(
                                                _vm.transportModeList,
                                                function(option) {
                                                  return _c("el-option", {
                                                    key: option.val,
                                                    attrs: {
                                                      label: option.text,
                                                      value: option.val
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _vm._m(15),
                                        _c(
                                          "div",
                                          { staticClass: "pull-left " },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择运费承担"
                                                },
                                                model: {
                                                  value: _vm.freightBearSel,
                                                  callback: function($$v) {
                                                    _vm.freightBearSel = $$v
                                                  },
                                                  expression: "freightBearSel"
                                                }
                                              },
                                              _vm._l(
                                                _vm.freightBearList,
                                                function(option) {
                                                  return _c("el-option", {
                                                    key: option.val,
                                                    attrs: {
                                                      label: option.text,
                                                      value: option.val
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _vm._m(16),
                                        _c(
                                          "div",
                                          { staticClass: "pull-left " },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder:
                                                    "请选择诉讼所在地"
                                                },
                                                model: {
                                                  value: _vm.lawsuitLocationSel,
                                                  callback: function($$v) {
                                                    _vm.lawsuitLocationSel = $$v
                                                  },
                                                  expression:
                                                    "lawsuitLocationSel"
                                                }
                                              },
                                              _vm._l(
                                                _vm.lawsuitLocationList,
                                                function(option) {
                                                  return _c("el-option", {
                                                    key: option.val,
                                                    attrs: {
                                                      label: option.text,
                                                      value: option.val
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pull-left pad15_l pad30_r"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "clearfix normal pad35_l"
                                              },
                                              [
                                                _c(
                                                  "em",
                                                  { staticClass: "red" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(
                                                  "短溢量(仅适用于大宗原料)：±\n                  "
                                                ),
                                                _c("el-input-number", {
                                                  staticClass: "w80 mar5 dpad5",
                                                  attrs: {
                                                    "controls-position":
                                                      "right",
                                                    size: "small",
                                                    precision: 2,
                                                    step: 1,
                                                    min: 0.01,
                                                    max: 100
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.inputNumberChange(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.shortSpillover,
                                                    callback: function($$v) {
                                                      _vm.shortSpillover = $$v
                                                    },
                                                    expression: "shortSpillover"
                                                  }
                                                }),
                                                _vm._v(
                                                  "%，在此范围内根据实际交货数量及本合同约定销售单价计算最终合同价款。\n                "
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "clear pad35_l paymethod"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix" },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "甲方逾期交付产品的，每逾期一天，应按照合同总价款的\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 2,
                                                        step: 1,
                                                        min: 0.01,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.firstPartyFalsifyRate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.firstPartyFalsifyRate = $$v
                                                        },
                                                        expression:
                                                          "firstPartyFalsifyRate"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "%向乙方支付违约金，逾期超过5天的，则乙方有权解除合同，且甲方应当全额退还乙方已经支付的合同价款。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix" },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "乙方逾期付款的，每逾期一天，应按照合同未付款的\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 2,
                                                        step: 1,
                                                        min: 0.01,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.secondPartyFalsifyRate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.secondPartyFalsifyRate = $$v
                                                        },
                                                        expression:
                                                          "secondPartyFalsifyRate"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "%向甲方支付违约金。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix" },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "乙方应在当批次货物验收合格后\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 15
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.secondPartyInspectionDays,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.secondPartyInspectionDays = $$v
                                                        },
                                                        expression:
                                                          "secondPartyInspectionDays"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内在平台上确认收货，逾期未确认收货的，平台在甲方提供验收合格相关证明后在确认\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix" },
                                                  [
                                                    _vm._v(
                                                      "\n                    收货期限届满之日起\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 15
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.platformAdvanceDays,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.platformAdvanceDays = $$v
                                                        },
                                                        expression:
                                                          "platformAdvanceDays"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内自动将该批次对应货款划给甲方。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix" },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "产品到达收货地点后，采用火车或轮船运输的乙方应在存放方通知或要求的可免费存放并提货时间内，\n                    采用汽车运输的乙方应在到货后\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 15
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.motorTransportInspectionDays,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.motorTransportInspectionDays = $$v
                                                        },
                                                        expression:
                                                          "motorTransportInspectionDays"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内，由乙方按双方按约定的包装和质量标准进行验收。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix" },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "乙方有异议的应在验收后\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 15
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.motorTransportAcceptanceDays,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.motorTransportAcceptanceDays = $$v
                                                        },
                                                        expression:
                                                          "motorTransportAcceptanceDays"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内以书面方式（含邮件）反馈给甲方，否则视为所交付产品符合约定并完成交货。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix" },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "甲方应在乙方支付最后一笔款项前，先行向乙方开具全额的合法增值税发票（应税商品应开具增值税专用发票），甲方未按约定及时开具全额发票的，乙方有权延迟支付本协议第5.1条约定的尾款且不构成违约，且每逾期一日甲方应按未开票金额的\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 2,
                                                        step: 1,
                                                        min: 0.01,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.notInvoicedAmountRate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.notInvoicedAmountRate = $$v
                                                        },
                                                        expression:
                                                          "notInvoicedAmountRate"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "%向乙方支付违约金。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._m(17)
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm.templateMethodSel == "XS-PTKH"
                                ? [
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _vm._m(18),
                                        _c(
                                          "div",
                                          { staticClass: "pull-left " },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择支付方式"
                                                },
                                                on: {
                                                  change: _vm.paymentMethodPTSel
                                                },
                                                model: {
                                                  value:
                                                    _vm.paymentMethodPTValue[0],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.paymentMethodPTValue,
                                                      0,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "paymentMethodPTValue[0]"
                                                }
                                              },
                                              _vm._l(
                                                _vm.paymentMethodPTList,
                                                function(option) {
                                                  return _c("el-option", {
                                                    key: option.val,
                                                    attrs: {
                                                      label: option.name,
                                                      value: option.val
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pull-left pad15_l pad30_r",
                                            staticStyle: {
                                              "padding-left": "90px"
                                            }
                                          },
                                          [
                                            _vm.paymentMethodPTValue[0] == "4"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clearfix normal pad35_l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  本合同签署后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[1],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[1]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内乙方付\n                  "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[2],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            2,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[2]"
                                                      }
                                                    }),
                                                    _vm._v("%款项，"),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  产品、货物装车/装船后当日内乙方付"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 0,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[3],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            3,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[3]"
                                                      }
                                                    }),
                                                    _vm._v("%款项，"),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  乙方及下游客户确认收货后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[4],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            4,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[4]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内付\n                  "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 0,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[5],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            5,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[5]"
                                                      }
                                                    }),
                                                    _vm._v("%款项，"),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  甲方收到乙方"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 0,
                                                        max: 100
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[7],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            7,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[7]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "%货款后\n                  "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[6],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            6,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[6]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内，甲方上游供应商向乙方指定的地点和收货人发货。\n                "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.paymentMethodPTValue[0] == "1"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clearfix normal pad35_l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  本合同签署后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[2],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            2,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[2]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内，甲方上游供应商向乙方指定的地点和收货人发货。"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  本合同签署后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[1],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[1]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内乙方通过平台将全款结算给甲方。\n                "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.paymentMethodPTValue[0] == "2"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clearfix normal pad35_l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  乙方对该订单或批次货物验收合格并确认收货后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[1],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[1]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内，乙方将全部货款通过平台结算给甲方"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                  本合同签订后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .paymentMethodPTValue[2],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paymentMethodPTValue,
                                                            2,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paymentMethodPTValue[2]"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内，甲方上游供应商向乙方指定的地点和收货人发货。\n                "
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "clearfix pad30_l"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "pad10_r block normal"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "客户对货品质量标准的特别约定"
                                                    )
                                                  ]
                                                ),
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "500px"
                                                  },
                                                  attrs: {
                                                    type: "textarea",
                                                    placeholder: "请输入内容",
                                                    maxlength: 200,
                                                    "show-word-limit": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.specialQualityAgreement,
                                                    callback: function($$v) {
                                                      _vm.specialQualityAgreement = $$v
                                                    },
                                                    expression:
                                                      "specialQualityAgreement"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _vm._m(19),
                                        _c(
                                          "div",
                                          { staticClass: "pull-left " },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择运费承担"
                                                },
                                                model: {
                                                  value: _vm.freightBearPTSel,
                                                  callback: function($$v) {
                                                    _vm.freightBearPTSel = $$v
                                                  },
                                                  expression: "freightBearPTSel"
                                                }
                                              },
                                              _vm._l(
                                                _vm.freightBearPTList,
                                                function(option) {
                                                  return _c("el-option", {
                                                    key: option.val,
                                                    attrs: {
                                                      label: option.text,
                                                      value: option.val
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _vm._m(20),
                                        _c(
                                          "div",
                                          { staticClass: "pull-left " },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder:
                                                    "请选择诉讼所在地"
                                                },
                                                model: {
                                                  value: _vm.lawsuitLocationSel,
                                                  callback: function($$v) {
                                                    _vm.lawsuitLocationSel = $$v
                                                  },
                                                  expression:
                                                    "lawsuitLocationSel"
                                                }
                                              },
                                              _vm._l(
                                                _vm.lawsuitLocationList,
                                                function(option) {
                                                  return _c("el-option", {
                                                    key: option.val,
                                                    attrs: {
                                                      label: option.text,
                                                      value: option.val
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "clearfix mar20_b" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pull-left pad15_l pad30_r"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "clearfix normal pad35_l"
                                              },
                                              [
                                                _c(
                                                  "em",
                                                  { staticClass: "red" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(
                                                  "短溢量(仅适用于大宗原料)：±\n                  "
                                                ),
                                                _c("el-input-number", {
                                                  staticClass:
                                                    "border w80 mar5 dpad5",
                                                  attrs: {
                                                    "controls-position":
                                                      "right",
                                                    size: "small",
                                                    precision: 2,
                                                    step: 1,
                                                    min: 0.01,
                                                    max: 100
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.inputNumberChange(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.shortSpillover,
                                                    callback: function($$v) {
                                                      _vm.shortSpillover = $$v
                                                    },
                                                    expression: "shortSpillover"
                                                  }
                                                }),
                                                _vm._v(
                                                  "%，在此范围内根据实际交货数量及本合同约定销售单价计算最终合同价款。\n                "
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "clear pad35_l paymethod"
                                              },
                                              [
                                                _vm._m(21),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _vm._m(22),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix  " },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "乙方应在当批次货物收货后\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w60 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 15
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.secondPartyInspectionDays,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.secondPartyInspectionDays = $$v
                                                        },
                                                        expression:
                                                          "secondPartyInspectionDays"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内在平台上确认收货，逾期未确认收货的，平台在甲方提供相关交货证明后自动将该批次对应货款划给甲方。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix  " },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "产品到达收货地点后，采用火车或轮船运输的乙方应在存放方通知或要求的可免费存放并提货时间内，采用汽车运输的乙方应在到货后\n                    "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 15
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.motorTransportInspectionDays,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.motorTransportInspectionDays = $$v
                                                        },
                                                        expression:
                                                          "motorTransportInspectionDays"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内，由乙方按双方按约定的包装和质量标准进行验收。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "clearfix  " },
                                                  [
                                                    _c(
                                                      "em",
                                                      { staticClass: "red" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "乙方有异议的应在验收后"
                                                    ),
                                                    _c("el-input-number", {
                                                      staticClass:
                                                        "border w80 mar5 dpad5",
                                                      attrs: {
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        precision: 0,
                                                        step: 1,
                                                        min: 1,
                                                        max: 15
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputNumberChange(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.motorTransportAcceptanceDays,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.motorTransportAcceptanceDays = $$v
                                                        },
                                                        expression:
                                                          "motorTransportAcceptanceDays"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "日内以书面方式（含邮件）反馈给甲方或甲方上游供应商，否则视为所交付产品符合约定并完成交。\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("div", {
                                                  staticClass: "box10"
                                                }),
                                                _vm._m(23),
                                                _vm._m(24)
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _c("ul", [
                            _c(
                              "li",
                              { staticClass: "clearfix mar20_b pad35_l" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "pull-left pad15_l pad30_r" },
                                  [
                                    _c("div", { staticClass: "box10" }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix normal pad30_l"
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "pad10_r block normal"
                                          },
                                          [
                                            _vm._v(
                                              "双方对赔付拒收标准的特别约定"
                                            )
                                          ]
                                        ),
                                        _c("el-input", {
                                          staticStyle: { width: "500px" },
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "请输入内容",
                                            maxlength: 200,
                                            "show-word-limit": ""
                                          },
                                          model: {
                                            value:
                                              _vm.twoPartyRejectionAppointment,
                                            callback: function($$v) {
                                              _vm.twoPartyRejectionAppointment = $$v
                                            },
                                            expression:
                                              "twoPartyRejectionAppointment"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix normal pad30_l"
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "pad10_r block normal"
                                          },
                                          [_vm._v("双方对违约责任的特别约定")]
                                        ),
                                        _c("el-input", {
                                          staticStyle: { width: "500px" },
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "请输入内容",
                                            maxlength: 200,
                                            "show-word-limit": ""
                                          },
                                          model: {
                                            value:
                                              _vm.twoPartyFalsifyAppointment,
                                            callback: function($$v) {
                                              _vm.twoPartyFalsifyAppointment = $$v
                                            },
                                            expression:
                                              "twoPartyFalsifyAppointment"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "clearfix pad30_l" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "pad10_r block normal"
                                          },
                                          [_vm._v("电子合同补充条款")]
                                        ),
                                        _c("el-input", {
                                          staticStyle: { width: "500px" },
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "请输入内容",
                                            maxlength: 200,
                                            "show-word-limit": ""
                                          },
                                          model: {
                                            value: _vm.contractSupplement,
                                            callback: function($$v) {
                                              _vm.contractSupplement = $$v
                                            },
                                            expression: "contractSupplement"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "mar20-t text-center" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isSubmitSave },
                        on: { click: _vm.save }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "con-box50" })
              ]
            : _vm._e(),
          !_vm.alertEditbox
            ? _c(
                "el-empty",
                { attrs: { description: _vm.alertEditMsg } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.callback } },
                    [_vm._v("返回列表")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "pad30_r pull-left " }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("合同模板名称")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("合同模板类型")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "clearfix mar20_b" }, [
      _c("label", { staticClass: "f18 fb pad20_r pull-left text-right" }, [
        _vm._v("一、交货时间、方式和地点")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "clearfix mar20_b" }, [
      _c("label", { staticClass: "f18 fb pad20_r pull-left text-right" }, [
        _vm._v("二、安装调试和培训")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("安装\\培训方式")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "clearfix mar20_b" }, [
      _c("label", { staticClass: "f18 fb pad20_r pull-left text-right" }, [
        _vm._v("三、设备验收")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "clearfix mar20_b" }, [
      _c("label", { staticClass: "f18 fb pad20_r pull-left text-right" }, [
        _vm._v("四、质量保修")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "clearfix mar20_b" }, [
      _c("label", { staticClass: "f18 fb pad20_r pull-left text-right" }, [
        _vm._v("五、违约责任")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "clearfix mar20_b" }, [
      _c("label", { staticClass: "f18 fb pad20_r pull-left text-right" }, [
        _vm._v("六、补充条款")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "clearfix mar20_b" }, [
      _c("label", { staticClass: "f18 fb pad20_r pull-left text-right" }, [
        _vm._v("一、关于收费")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("支付方式")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "clearfix mar20_b" }, [
      _c("label", { staticClass: "f18 fb pad20_r pull-left text-right" }, [
        _vm._v("二、补充条款")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("合同模板类型")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("支付方式")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("运输方式")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("运费承担")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("诉讼所在地")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "span",
        { staticStyle: { color: "#7F7F7F", "background-color": "#F4F4F4" } },
        [_vm._v("此条款仅与平台方进行交易时有效，并进行展示")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("支付方式")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("运费承担")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "w130 pad30_r pull-left text-right" }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v("诉讼所在地")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix  " }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v(
        "甲方逾期交付产品的，每逾期一天，应按照合同总价款的0.05%向乙方支付违约金，逾期超过5天的，则乙方有权解除合同，且甲方应当全额退还乙方已经支付的合同价款。\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix  " }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v(
        "乙方逾期付款的，每逾期一天，应按照合同未付款的0.05%向甲方支付违约金。\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix  " }, [
      _c("em", { staticClass: "red" }, [_vm._v("*")]),
      _vm._v(
        "甲方应在收到全部款项后，向乙方开具合法增值税普通发票。\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "span",
        { staticStyle: { color: "#7F7F7F", "background-color": "#F4F4F4" } },
        [_vm._v("此条款仅与平台方进行交易时有效，并进行展示")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }